// Copied from vendor-ref/mara/app/ui/src/data/viewer-tools.js, minus the Measurement tool and its modes
// (tagged [excluded: measurement] in docs/research/sections/web-ui-viewer__02.md). Icons and labels match the XR client.
import type { SelectionMode, Tool } from '@nanome-lite/state';

export const TOOLS: Record<Tool, { label: string; icon: string }> = {
  default: { label: 'Default', icon: 'i-tabler-droplet' },
  selection: { label: 'Selection', icon: 'i-tabler-lasso' },
};

export const TOOL_MODES: Record<SelectionMode, { label: string; icon: string }> = {
  atom: { label: 'Atom', icon: 'i-tabler-atom' },
  residue: { label: 'Residue', icon: 'i-tabler-hexagons' },
  chain: { label: 'Chain', icon: 'i-tabler-scribble' },
};

/** Unity ToolModes (ToolsViewModel.cs:100-111): Selection = [Atom, Residue, Chain]. */
export const TOOL_MODE_ORDER: SelectionMode[] = ['atom', 'residue', 'chain'];
